export const TIME_TRACKER_MENU_URL_PATH =
  '/api/v2/time-tracker/active?$expand=task,timeRegistration,absenceCode';

export const POST_TIME_TRACKER_MSW_STATUS_KEY = 'timeTrackerAPI';
export const POST_TIME_TRACKER_KEY = 'POST_TIME_TRACKER';

export const GET_TIME_TRACKER_MSW_STATUS_KEY = 'getTimeTrackerAPI';
export const GET_TIME_TRACKER_KEY = 'GET_TIME_TRACKER';
